import { useClient, fetchCurrentClient } from "~/composables/useAuth";

export default defineNuxtPlugin(async () => {
  const client = useClient();

  if (client.value === undefined || client.value === null) {
    try {
      const response = await fetchCurrentClient();
      client.value = response ? response.data : null;
    } catch {
      // Never let an auth lookup failure (network blip, 5xx, SSR cookie
      // edge cases) break the server render — fall back to "logged out".
      client.value = null;
    }
  }
});
